/**
 * Stichting FIN — logo component
 *
 * Toont het volledige logo (icoon + wordmark + payoff) uit /public/logo-fin.png.
 * Voor kleine plekken (icons, favicon-achtige) gebruikt `variant="mark"` een
 * uitsnede van het icoon.
 */
export default function Logo({ height = 56, variant = "full", className = "" }) {
  const src = variant === "mark" ? "/logo-192.png" : "/logo-fin.png";
  const alt = "Stichting FIN — Kansen vandaag, toekomst voor altijd";
  return (
    <img
      src={src}
      alt={alt}
      className={`block object-contain ${className}`}
      style={{ height, width: "auto" }}
      loading="eager"
      decoding="async"
      data-testid="brand-logo"
    />
  );
}
